export const EVENT_TIME_ENTRY_ADDED = 'EVENT_TIME_ENTRY_ADDED';

export const changeWorkStatus = async (status) => {
    const response = await axios.post(`/users/attendances/add`, {status});

    return response.data;
}

export const getTodayAttendanceTimesheet = async () => {
    const response = await getAttendanceTimesheets();

    return response?.data?.data[0] ?? null;
}

export const getAttendanceTimesheets = async (startDate, endDate) => {
    const url = (startDate && endDate)
        ? `/users/attendances/status-timesheet?start_date=${startDate}&end_date=${endDate}`
        : '/users/attendances/status-timesheet';

    const response = await axios.get(url);

    return response.data;
}
